import userAnalyticsConstants from 'Assets/js/Vuex/Store/actions/UserAnalyticsConstants';

const actions = {
  forceUserRecommendations(context, id) {
    context.getters.userInstance.forceRecommendProduct(id, (response) => {
      if (!Array.isArray(response) || response.length === 0) {
        context.commit('setUserRecommendations', []);
        return;
      }
      const testArray = Array.from({ length: 8 }, () => response[0]);
      context.commit('setUserRecommendations', testArray);
    });
  },
  fetchUserRecommendations(context) {
    /*
    context.getters.userInstance.recommendProducts((response) => {
      context.commit('setUserRecommendations', response);
    });
    */
  },
  fetchEinsteinProductRecommendations(context) {
    /*
    context.getters.userInstance.einsteinCartRecommendations((response) => {
      context.commit('setUserCartRecommendations', response);
    });
    context.getters.userInstance.einsteinProductRecommendations((response) => {
      context.commit('setUserRecommendations', response);
    });
    */
  },
  updatePageViewCount(context) {
    /*
      if (
        context.getters.getPageViewCount === 0 ||
        context.getters.getRecommendedProducts?.length === 0
      ) {
        context.dispatch('fetchEinsteinProductRecommendations').then(() => {});
      }
      if (
        context.getters.getPageViewCount <
        userAnalyticsConstants.einsteinPageMaxView - 1
      ) {
        context.commit('addPageView');
      } else {
        context.commit('resetPageView');
      }
    */
  }
};

export default actions;
